import { render } from "./LinkPreview.vue?vue&type=template&id=45c6f87b&ts=true"
import script from "./LinkPreview.vue?vue&type=script&lang=ts"
export * from "./LinkPreview.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/LinkPreview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45c6f87b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45c6f87b', __exports__)) {
    api.reload('45c6f87b', __exports__)
  }
  
  module.hot.accept("./LinkPreview.vue?vue&type=template&id=45c6f87b&ts=true", () => {
    api.rerender('45c6f87b', render)
  })

}


export default __exports__